import { ReactElement } from 'react';
import { Controller, Control, FieldErrors, FieldValues, Path } from 'react-hook-form';
import get from 'lodash/get';
import FormControl, { FormControlProps } from '@mui/material/FormControl';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  size?: FormControlProps['size'];
  name: string;
  label?: string;
  disabled?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  cb?: (value?: boolean) => void;
}

const CheckboxComponent = <TFieldValues extends FieldValues = FieldValues>({
  control,
  errors,
  size = 'medium',
  name,
  label = '',
  disabled = false,
  labelPlacement,
  cb,
}: IProps<TFieldValues>): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field: { value, onChange } }) => (
        <FormControl variant="outlined">
          <FormControlLabel
            control={
              <Checkbox
                checked={value}
                color="primary"
                size={size}
                onChange={e => {
                  onChange(e);
                  cb?.(e.target.checked);
                }}
              />
            }
            label={label}
            disabled={disabled}
            labelPlacement={labelPlacement}
          />
          {error && <FormHelperText error>{error.toString()}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default CheckboxComponent;
